<div>
  <h3>สมัครใช้บริการออนไลน์ของท่านไม่สำเร็จ</h3>
</div>
<div class="uk-flex uk-flex-middle uk-flex-column ">
  <div class="uk-margin-bottom">
    <div [innerHTML]="body | sanitizeHtml"></div>
  </div>
  <div class="uk-margin-top">
    <button type="submit"
      class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
      (click)="onOk()">{{btnOk()}}
    </button>
    <!-- <div class="uk-margin-top">
      <a class="uk-text-meta uk-margin-small-right" (click)="redirectToChateRoom()"><u>กลับไปยังห้องสนทนา</u></a>
    </div> -->
  </div>
</div>